import { usePrivileges } from '@/app/state/auth/index.hooks';
import * as yup from 'yup';
import { validationSchema as userDataValidationSchema } from '../DataTab/validationSchema';
import { validationSchema as userReportsValidationSchema } from '../ReportsTab/validationSchema';

export const useValidationSchema = () => {
    const { manageReportDefinitionsAssignment } = usePrivileges();

    if (manageReportDefinitionsAssignment) {
        return yup.object().shape({
            data: userDataValidationSchema,
            reports: userReportsValidationSchema,
        });
    } else {
        return yup.object().shape({
            data: userDataValidationSchema,
        });
    }
};
